export const formatPlanName = (
  paymentPlan: { planName: string; planNameLocale: string },
  t: (key: string) => string,
): string => {
  if (paymentPlan.planNameLocale.includes('Free Trial')) {
    return paymentPlan.planNameLocale;
  }
  if (paymentPlan.planName === 'FREE') {
    return `${t('orgSwitcher.planCopy')} ${paymentPlan.planNameLocale}`;
  }

  return `${paymentPlan.planNameLocale} ${t('orgSwitcher.planCopy')}`;
};
